export const get_appinfo = () => fetch("api/appinfo").then(r => r.json());